import selectInsurance from 'utils/selectInsurance';

const getInsurancePlanAndType = ({ patient, insurance, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  const selectedInsurance = insurance || selectInsurance(patient['Insurance Information']);
  return selectedInsurance && selectedInsurance['Claim Filling Code']
    && selectedInsurance['Claim Filling Code']['Full Name']
    ? selectedInsurance['Claim Filling Code']['Full Name'] : null;
};

export default getInsurancePlanAndType;



// WEBPACK FOOTER //
// ./src/utils/print/getInsurancePlanAndType.js